import {makeAutoObservable} from 'mobx'
import * as Api from '@/utils/api/api'
import RecommendListStore from './RecommendListStore'

class MyStore {
    // private
/*    id = 0
    username = ''
    nickname = ''
    avatar = ''
    gender = -1
    birthday = ''*/
    // public
    goodsNum = 0
    shopsNum = 0
    footprintsNum = 0
    recommendListStore = new RecommendListStore()

    constructor() {
        makeAutoObservable(this)
    }

    /**
     * 获取用户信息
     */
    async fetchInfo() {
        try {
            // const {info} = await Api.userInfo()

/*            const {id, username, avatar, nickname, gender, birthday} = info

            this.id = id
            this.username = username || ''
            this.avatar = avatar || ''
            this.nickname = nickname || ''
            this.gender = gender === 0 ? 0 : 1
            this.birthday = birthday*/
        } catch (error) {
        }
    }

    /**
     * 获取推荐列表
     */
    async fetchRecommendList() {
        await this.recommendListStore.fetchList()
    }

}

const store = new MyStore()

export default store
